import { useCallback, useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { FetchResult } from '@apollo/client';
import {
  RetryInstallationFlowInput,
  RetryInstallationFlowMutation,
  useRetryInstallationFlowMutation
} from 'graphql/types';
export const useRetryInstallationFlow = (): {
  retryInstallationFlow: (
    input: RetryInstallationFlowInput
  ) => Promise<
    FetchResult<
      RetryInstallationFlowMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    RetryInstallationFlowMutation,
    { loading, error }
  ] = useRetryInstallationFlowMutation();

  const retryInstallationFlow = useCallback(
    async (input: RetryInstallationFlowInput) =>
      await RetryInstallationFlowMutation({
        variables: {
          input
        }
      }),
    [RetryInstallationFlowMutation]
  );
  return useMemo(
    () => ({
      retryInstallationFlow,
      loading,
      error
    }),
    [retryInstallationFlow, loading, error]
  );
};
